import React, { memo, useEffect, useRef, useState } from 'react'

import * as _ from 'lodash'
import styled from 'styled-components'
import PerfectScrollbar from 'react-perfect-scrollbar'
import IconPolygon from 'assets/img/icon/icon_polygon.png'
import IconPolygon2 from 'assets/img/icon/icon_polygon_2.png'

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 32px;
  border: 1px solid ${props => props.isFocus ? '#F0B90B' : '#4e4d62'};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 20px 8px 12px;
  background: transparent;
  background-image: url(${props => props.active ? IconPolygon : IconPolygon2});
  background-repeat: no-repeat;
  background-position-x: calc(100% - 5px);
  background-position-y: 50%;
  color: ${props => props.active ? 'var(--half_white)' : '#818181'};

  .select-value {
    position: relative;
    width: 100%;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }

  .select-option {
    display: none;
    position: absolute;
    top: 33px;
    left: -2px;
    padding: 0;
    background: #1c192c;
    box-shadow: 0px 10px 24px -4px rgba(255, 255, 255, 0.08),
      0px 4px 8px -4px rgba(255, 255, 255, 0.03);
    border-radius: 4px;
    width: 303px;
    overflow: hidden;
    z-index: 3;

    &.active {
      display: block;
    }

    .scrollbar-container {
      max-height: 200px;
    }

    li {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: var(--half_white);
      padding: 8px 16px;

      //&:nth-child(2n) {
      //  background: #353347;
      //}
      //&:hover{
      //  background: #3f3d55;
      //}
      &:hover{
        background: #353347;
      }
    }
  }
`

function RenderSelect(props) {
  const wrapperRef = useRef()
  const [show, setShow] = useState(false)
  const [showText, setShowText] = useState('')

  const {
    input: { value, onChange },
    arrOpt,
    isActive,
    meta: { touched, error },
  } = props

  useEffect(() => {
    if (value && arrOpt && !!arrOpt.length) {
      const optSelected = _.find(arrOpt, (o) => o.value == value)

      console.log(value)

      setShowText(optSelected?.label)
    }
  }, [value])

  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutside)
    // See note below
    return () => window.removeEventListener('mousedown', handleClickOutside)
  })

  function _handleShow() {
    setShow(true)
  }

  function handleClickOutside(event) {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShow(false)
    }
  }

  function _handleSelect(record) {
    onChange(record)
    // setShowText(record.MALO);
    setShow(false)
  }

  return (
    <Container ref={wrapperRef} active={isActive || show} isFocus={show} style={{
        borderColor: `${touched && error ? '#FF0000' : '#4e4d62'}`,
      }}>
      <div className="select-value" onClick={_handleShow}>
        {showText || 'Chọn'}
      </div>
      <ul className={'select-option' + (show ? ' active' : '')}>
        <PerfectScrollbar>
          {arrOpt &&
            !!arrOpt.length &&
            arrOpt.map((item, index) => (
              <li key={index} onClick={() => _handleSelect(item.value)}>
                {item.label}
              </li>
            ))}
        </PerfectScrollbar>
      </ul>
    </Container>
  )
}

export default memo(RenderSelect)
